import { Observable, of } from 'rxjs'
import { Route } from '@angular/router'
import { Injectable } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { catchError, map, switchMapTo, take, tap } from 'rxjs/operators'
import { selectRentalsSubDomainLoaded } from './rental.selectors'
import { IsDataLoaded } from '../../services/data-checker.service'
import { loadSubdomain } from './rental.actions'

@Injectable()
export class SubdomainGuard implements IsDataLoaded {
  constructor(private store: Store<any>) {}

  public canActivate(): Observable<boolean> {
    return this.isDataLoaded().pipe(
      switchMapTo(of(true)),
      catchError(() => of(false))
    )
  }

  isDataLoaded(): Observable<boolean> {
    return this.store.pipe(
      select(selectRentalsSubDomainLoaded),
      tap((isLoaded) => {
        if (!isLoaded) {
          this.store.dispatch(loadSubdomain())
        }
      }),
      map(() => true),
      take(1)
    )
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate()
  }
}
